import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { MenuComponent } from './components/menu/menu.component';
import { PageAccessService } from './shared/service/page-access.service';
import { NotificationComponent } from './shared/components/notification/notification.component';
import { NotificationService } from './shared/service/notification.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  imports: [CommonModule, MenuComponent, NotificationComponent],
})
export class AppComponent implements OnInit {
  isLogin: boolean = false;
  private readonly destroy$ = new Subject<void>();

  readonly availablePages = [
    { route: '/contagem', title: 'Contagem', icon: 'an an-list-numbers' },
    { route: '/pack', title: 'Pack', icon: 'an an-package' },
    { route: '/balanco', title: 'Balanço', icon: 'an an-balance-weight' },
    { route: '/embarque', title: 'Embarque', icon: 'an an-pallet-partial' },
    { route: '/avulsa', title: 'Avulsa', icon: 'an an-list-numbers' },
    { route: '/production-order-movement', title: 'Movimentação OP', icon: 'an an-workflow' },
    {
      route: '/production-order-finalization',
      title: 'Finalização OP',
      icon: 'an an-check-circle',
    },
    { route: '/consulta-preco', title: 'Consulta Preço', icon: 'an an-tag' },
  ];

  constructor(
    private router: Router,
    private pageAccessService: PageAccessService,
    private notificationService: NotificationService
  ) { }

  ngOnInit(): void {
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        if (this.router.url !== '/home') {
          const pageInfo = this.availablePages.find(page => page.route === this.router.url);
          if (pageInfo) {
            this.pageAccessService.addPageAccess(this.router.url, pageInfo);
          }
        }
      }
    });

    this.notificationService.finalizationResult$
      .pipe(takeUntil(this.destroy$))
      .subscribe(result => {
        this.notificationService.dismissByTag(`finalization-${result.countCode}`);
        this.notificationService.unmarkAsProcessing(result.countCode);
        if (result.success) {
          this.notificationService.success(`Contagem ${result.countCode} finalizada com sucesso!`);
        }
      });
  }
}
